import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DevicesClass } from '@app/core/classes';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-page-shell',
  templateUrl: 'shell.component.html',
  styleUrls: [`./shell.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ShellComponent extends DevicesClass implements OnInit {
  public ShellScreen: boolean;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private router: Router,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.router.events.pipe(untilDestroyed(this)).subscribe((e: RouterEvent) => {
      if (e instanceof NavigationEnd) {
        this.onSetScreenLayer();
      }
    });

    this.onSetScreenLayer();
  }

  onSetScreenLayer(): void {
    this.ShellScreen =
      location.pathname === '/bulletins/success' ||
      location.pathname === '/loyalty/sign-success';

    this.cdr.markForCheck();
  }
}
